import React, { useEffect, useState } from 'react'
import Layout from '../Layout'
import { Box, Button, CircularProgress, Container, Divider, Grid, List, ListItem, ListItemText, Paper, TextField, Typography, makeStyles } from '@material-ui/core'
import { useLocation } from 'react-router-dom'
import CustomBreadcrumbs from '../Breadcrumb'
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { attendBreakDown, getBreakdownDetails, } from '../../ReduxStore/Breakdown/BreakdownSlice';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import dayjs from 'dayjs';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library'
import { convertUTCtoIST } from '../../helpers/DateConvert'

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(4),
        maxWidth: 700,
        margin: '0 auto',
        paddingBlock: 30,
        marginTop: 10,
        marginBottom: 10
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
    formControl: {
        marginBottom: theme.spacing(2),
    },
    button: {
        marginTop: theme.spacing(2),
    },
    lowPriority: {
        color: 'green',
    },
    mediumPriority: {
        color: 'yellow',
    },
    highPriority: {
        color: 'red',
    },
}));

const AddObservation = () => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const breakdown_id = pathname[3];

    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Breakdown Management', href: '/breakdown-management' },
        { label: 'Current Breakdowns', href: '/breakdown-management/current-breakdowns' },
    ];

    const [loading, setLoading] = useState(true);
    const [postLoading, setPostLoading] = useState(false);
    const [observations, setObservations] = useState([]);
    const [breakDownDetails, setBreakdownDetails] = useState();



    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            machine_breakdown_id: breakdown_id,
            status_id: "6a1e0c17ccd6495ca8575882bf776f16",
            observation: observations,
            customer_id: "af33f9117ecb4d8d8def84d6331eebd4"
        }

        try {
            setPostLoading(true)
            const action = dispatch(attendBreakDown(payload));
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {
                setPostLoading(false)
                toast.success("Observation Added Successfully!");
                getbreakdownDetails();
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        } finally {
            setPostLoading(false)
        }


        // let observations = JSON.parse(localStorage.getItem("observation")) || [];

        // const newObservation = {
        //     assetNo: FormData.assetNo,
        //     observation: formData.observation
        // };
        // observations.push(newObservation);
        // localStorage.setItem("observation", JSON.stringify(observations));
    };

    const getbreakdownDetails = async () => {
        try {
            const action = dispatch(getBreakdownDetails(breakdown_id));
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {
                setBreakdownDetails(res.result.breakdown)
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            await getbreakdownDetails();
            setLoading(false);
        };
        fetchData();
    }, [])

    if (loading) {
        return (
          <Layout>
            <Container>
              <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                <GridLoadingSpinner />
              </Box>
            </Container>
          </Layout>
        );
      }

    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h3" component="h1" gutterBottom>
                        Add Observation
                    </Typography>
                </Box> */}
                <Box mt={1} mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Add Observation" />
                </Box>
                <Box>
                    <Paper className={classes.root}>
                        <form className={classes.form} onSubmit={handleSubmit} >
                            <Grid container spacing={3} >
                                <Grid item xs={12}>
                                    <TextField
                                        className={classes.formControl}
                                        label="Observation"
                                        name="observation"
                                        value={observations}
                                        onChange={(e) => setObservations(e.target.value)}
                                        variant="filled"
                                        fullWidth
                                        multiline
                                        minRows={4}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid item xs={6} sm={6}>
                                    <Button
                                        className={classes.button}
                                        variant="contained"
                                        fullWidth
                                        startIcon={<NotInterestedIcon />}
                                    >
                                        Discard
                                    </Button>
                                </Grid>
                                <Grid item xs={6} sm={6}>
                                    <Button
                                        className={classes.button}
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        startIcon={postLoading ? <CircularProgress size={20} /> : <CheckCircleIcon />}
                                        disabled={postLoading}
                                    >
                                        {postLoading ? "Submitting" : "Submit"}
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </Paper>
                </Box>
                <Box mt={2} style={{ border: '1px solid #ccc', borderRadius: '4px', padding: '12px' }} className={classes.root}>
                    {breakDownDetails && breakDownDetails.attendance.length > 0 ? (
                        <List>
                            {breakDownDetails.attendance.map((attend, index) => {
                                const timestamp = dayjs(attend.attended_timestamp).format('DD MMM, YYYY hh:mm A');
                                const observation = Object.values(attend.observation)[0]; // Get the first observation value

                                return (
                                    <div key={index}>
                                        <ListItem>
                                            <ListItemText
                                                primary={`${convertUTCtoIST(timestamp)} | ${attend.attended_username}`}
                                                secondary={observation}
                                            />
                                        </ListItem>
                                        {index < breakDownDetails.attendance.length - 1 && <Divider />}
                                    </div>
                                );
                            })}
                        </List>
                    ) : (
                        <ListItem>
                            <ListItemText primary="No attendance records available." />
                        </ListItem>
                    )}
                </Box>

            </Container>
            <ToastContainer />
        </Layout >
    )
}

export default AddObservation